var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92969 22C5.37969 22 4.90869 21.8043 4.51669 21.413C4.12535 21.021 3.92969 20.55 3.92969 20V6H5.92969V20H16.9297V22H5.92969ZM9.92969 18C9.37969 18 8.90902 17.8043 8.51769 17.413C8.12569 17.021 7.92969 16.55 7.92969 16V4C7.92969 3.45 8.12569 2.979 8.51769 2.587C8.90902 2.19567 9.37969 2 9.92969 2H18.9297C19.4797 2 19.9507 2.19567 20.3427 2.587C20.734 2.979 20.9297 3.45 20.9297 4V16C20.9297 16.55 20.734 17.021 20.3427 17.413C19.9507 17.8043 19.4797 18 18.9297 18H9.92969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.89b9afee45fef8c22ea5aa63cad8bb61.svg";
export { ForwardRef as ReactComponent };